import { Engine } from "@babylonjs/core";

export interface Screen {
  render(): void;
  dispose(): void;
}

export class App {
  private active: Screen | null = null;

  constructor(
    readonly engine: Engine,
    readonly canvas: HTMLCanvasElement,
  ) {
    engine.runRenderLoop(() => {
      this.active?.render();
    });
  }

  switchTo(screen: Screen): void {
    this.active?.dispose();
    this.active = screen;
  }
}
